import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
    providedIn: 'root'
})
export class SearchHistoryService {

    constructor(private dataService: DataService) { }
    getSearchHistory(searchQuery) {

        return this.dataService.getRecordWithParams('/api/AddressSearchHistory/GetSearchHistory', searchQuery);
    }
    getSessionLogData() {
        return this.dataService.getRecord('/api/spcenter/GetRadSessionDetails')
    }
    getSessionLogForSingleUser(searchQuery: any) {
        return this.dataService.post('/api/spcenter/GetUserSessionDetails', searchQuery)
    }
}
